import { Alias, aliasSelectors, AuthorityDataStore, authoritySelectors } from '@skinsoft/entity';
import _ from 'lodash';
import { of } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';
import { OfflineDataFetcher } from '../../..';

export class AliasOfflineDataFetcher extends OfflineDataFetcher<Alias>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public getByUser(userId: string) {
        return AuthorityDataStore.getInstance().fetchOneFromPredicate(
            authority => authoritySelectors.linkedAccount(authority) === userId
        )
            .pipe(
                first(),
                switchMap(
                    theLinkedAuthority => of(authoritySelectors.firstAlias(theLinkedAuthority))
                ),
            )
    }

}